var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Payments"},[_c('div',_vm._l((_vm.icons),function(icon,index){return _c('img',{key:index,attrs:{"src":require(("@/assets/images/" + (icon.icon))),"alt":"payment icon"}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }